// What a transfer screen shows while the product is off (lib/features.ts).
// Routable on purpose: a link ops shared last month must land somewhere that
// explains itself, not on a 404 that looks like a broken deploy.
import { Link } from '@tanstack/react-router';
import { PageHeader } from '@drivecars/admin-ui';

export function TransfersHidden() {
  return (
    <div className="flex flex-col gap-5">
      <PageHeader eyebrow="Operate" title="Airport transfers" sub="This product is not available right now." />
      <div className="rounded-lg border border-[color:var(--bo-line)] bg-[color:var(--bo-bg)] px-4 py-3 text-[13px] text-[color:var(--bo-ink)]">
        <p>Transfer screens are switched off. Existing transfer bookings are still listed under Bookings.</p>
        <p className="mt-2 text-[color:var(--bo-mute)]">
          Ask engineering to set <code>VITE_TRANSFERS_UI=true</code> on this deployment to bring them back.
        </p>
        <Link to={'/dashboard' as never} className="mt-3 inline-block underline underline-offset-4">
          Back to the dashboard
        </Link>
      </div>
    </div>
  );
}
